// slider for desk 

    // const text = document.querySelector(".follow-text p");
    // text.innerHTML = text.innerText
	// .split("")
	// .map(
	// 	(char, i) => `<span style="transform:rotate(${i * 5.8}deg)">${char}</span>`
	// )
	// .join("");

$(document).ready(function(){
    $('.real-result-wrap').slick({
        slidesToShow: 3,
        arrows:true,
        infinite: false,
        // autoplay:true,
        // autoplaySpeed: 3000,
        dots:true,
        speed: 500,
        prevArrow: '<button class="slide-arrow prev-arrow result"><img src="' + slider_arrow + '"></button>',
        nextArrow: '<button class="slide-arrow next-arrow result"><img src="' + slider_arrow + '"></button>',
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              arrows: true,
              slidesToShow: 2
            }
          },
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              slidesToShow: 1 
            }
          }
        ]
    });

    $('.product-items').slick({
        slidesToShow: 3,
        arrows:true,
        autoplay:true,
        autoplaySpeed: 3000,
        speed: 500,
        prevArrow: '<button class="slide-arrow prev-arrow result"><img src="' + slider_arrow + '"></button>',
        nextArrow: '<button class="slide-arrow next-arrow result"><img src="' + slider_arrow + '"></button>',
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    autoplay:false,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    autoplay:false,
                }
            }
        ]
    });

    $('.hamburger').on('click', function(){
        $('body').addClass('show-side-menu');
    })
    $('span.close-nav, .overly').on('click', function(){
        $('body').removeClass('show-side-menu');
    })
    $('h3.product-faq-title, .faq-title').on('click', function(){
        $(this).next().slideToggle();
        $(this).parent().toggleClass('active');
    })
    $('a.forget-link').on('click', function(){
        $('.login-contents').hide();
        $('.recover-contents').show();
    })
    $('a.recover-cancel').on('click', function(){
        $('.login-contents').show();
        $('.recover-contents').hide();
    })
    $('.product-tab-header-item').on('click', function(){
        $(this).addClass('active').siblings().removeClass('active');
        var id = $(this).data('id');
        $('#product_tab_'+id).addClass('active').siblings().removeClass('active');
    })
    $('button.risk-free-btn.btn').on('click', function(){
        $('html, body').animate({
            scrollTop: $("#single-product").offset().top
        }, 2000);
    })
    $('button.add_new_account.btn').on('click', function(){
       $('div#AddAddress').toggleClass('active');
    })
    $('button.add-cancel').on('click', function(){
       $('div#AddAddress').removeClass('active');
    })
    $('.edit-cancel').on('click', function(){
       $(this).parent().parent().parent().removeClass('active');
    })
    $('.edit-address').on('click', function(){
       $(this).parent().next().toggleClass('active');
    })
    $('.blog-select').on('change', function(){
        location.href = $(this).val();
    })
    $('button.risk-free-btn.button').on('click', function(){
        $('html, body').animate({
            scrollTop: $("#product-template").offset().top
        }, 2000);
    })
});

